import { Alert } from "antd";
import React from "react";
import { dateFromString } from "../../../../utils/dateFromString";
import { useSelector } from "react-redux";

export const EsNoProcedente = () => {
  const { motivoNoProcedente, fechaNoProcedente } = useSelector(
    (state) => state.detalleReducer.asistencia
  );

  return (
    <Alert
      warning
      style={{ marginBottom: 10 }}
      message={
        dateFromString(fechaNoProcedente).f1 +
        ": No procedente → " +
        motivoNoProcedente
      }
      type="warning"
      showIcon
    />
  );
};
